import { AppEnvironment } from '@shure/cloud/shared/utils/config';
import { LogLevel } from '@shure/shared/angular/utils/logging';

export const environment: AppEnvironment = {
	production: false,
	deployEnvironment: 'dev',
	remoteLogging: false,
	authorization: {
		clientId: '0oa15psf9prHkyIyi0h8',
		oktaDomain: 'iam.dev.shure.services',
		oktaDomainExt: 'accountssb.shure.com',
		authServerPath: '/oauth2/default',
		scopes: ['openid', 'profile', 'email', 'offline_access', 'shure_tenant'],
		enableSecondaryIDP: false,
		secondaryIDP: '0oa11drlvpkrHCQQK0h8'
	},
	useClassicEngine: false,
	sysApi: {
		url: 'https://system-api.dev.shure.services/graphql',
		apiKey: '',
		useWsTransport: true
	},
	orgs: {
		groupsApiUrl: 'https://orgs.dev.shure.services/groups',
		licensesApiUrl: 'https://licenses.dev.shure.services/licenses',
		orgsApiUrl: 'https://orgs.dev.shure.services/organizations',
		rolesApiUrl: 'https://orgs.dev.shure.services/roles',
		usersApiUrl: 'https://orgs.dev.shure.services/users',
		pemissionsApiUrl: 'https://orgs.dev.shure.services/permissions',
		notificationsApiUrl: 'https://notifications-api.dev.shure.services/api/v1',
		notificationsWebSocketUrl: 'wss://notifications-api-sockets.dev.shure.services/ws',
		preferencesApiUrl: 'https://preferences-api.dev.shure.services/api/v1',
		featureRequestApiUrl: 'https://orgs.dev.shure.services/feature-requests',
		verificationCodeApiUrl: 'https://orgs.dev.shure.services/verification-code',
		chatAssistantApiUrl: 'https://chatbot-core-api.dev-ss.shure.services'
	},
	logLevel: LogLevel.Debug,
	useMockup: false,
	appVersion: '1.1.41.0',
	clientVersion: '1.2.1405.0',
	showOnlyIdp: false,
	maintenanceModeConfigFile: '/maintenance/maintenanceConfig.json',
	maintenanceModeEligibleDomains: ['cloud.shure.com', 'localhost'],
	cdmFeatureFlags: {
		maxConcurrentFWUpdates: 1000 // to be removed once FW Update V2 is supported
	},
	cdmPerformance: {
		inventoryLoadingPopcornTimeout: 15_000,
		connectionsQueryPageSize: 3000,
		nodesQueryConcurrency: 100,
		nodesQueryMaxNodeIDs: 25,
		watchQuerySubscriptionConcurrency: 500,
		deviceClaimingConcurency: 50,
		deviceUnclaimingConcurrency: 50,
		deletePendingClaimBatchSize: 10
	},
	// non-cdm flags needed
	featureFlags: {
		maintenanceModeEnabled: true
	},

	signInMethod: 'okta-hosted',
	signOutScope: 'signout-okta',

	shureCloudUriMap: [
		{
			urlPattern: 'services',
			shureCloudUri: 'https://ignite.dev.shure.services/'
		},
		{
			urlPattern: 'com',
			shureCloudUri: 'https://dev.cloud.shure.com/'
		},
		{
			urlPattern: 'localhost',
			shureCloudUri: 'http://localhost:4201/'
		}
	],
	appType: 'device',
	appRoles: ['organization-admin', 'device-admin', 'user-license-and-device-admin'],
	application: 'cloud-device-management',
	statsigConfig: {
		clientKey: 'client-xZOWPyY999UU1WSCAXMYKY1rGnmOexVPXgewLw9bjyw',
		tier: 'dev',
		proxyApi: 'https://qgvg32qzhcbqnjbsl7czs4a3ta0yefpp.lambda-url.ap-south-1.on.aws/v1'
	},
	mixpanelProjectToken: 'a397a046e77dc07d2762094ba3ce408a'
};
